
<template>
	<div id="formview" ref="formView">
		<div id="main">
			<div class="inner">
				<header>
				<h1>Mitmachen</h1>
				<p v-if="!submitted">
					Wir freuen uns sehr, dass du deinen Vortrag/Film als Stream bei uns einbinden möchtest. Fülle dazu einfach die notwendigen Felder im folgendem Formular aus. Im Anschluss melden wir uns bei Dir und stimmen weitere Details ab.
					<br/> Wir freuen uns! Das sofareisen.org Team
				</p>
				</header>
				<section v-if="!submitted">
					<form id="form_new_entry" @submit.prevent="onSubmitted" method="post" :action="postUrl">
						<div class="row gtr-uniform">
							<h2 class="col-12 mb-1">Daten zum Vortrag / Film</h2>

							<!-- Source -->
							<input type="hidden" id="source" name="source"  value="sofareisen-neuer-stream">
							<!-- Infos zum Vortrag / Film -->
							<div class="col-12">
								<input type="text" name="title" id="form-title" v-model="title" placeholder="Überschrift" maxlength="50">
								<p class="form-descr second-color">Titel deines Vortrags / Films</p>
							</div>
							<div class="col-12">
								<textarea name="form-teaser" v-model="teaser" id="form-teaser" placeholder="Kurzbeschreibung zum Vortrag/Film" rows="2" class="form-textarea"></textarea>
								<div class="pt-05 col-12">
									<p class="form-descr second-color">Eine Kurzbeschreibung (Teasertext) zum Vortrag / Film. 1-2 Sätze zum Thema</p>
								</div>
							</div>
							<div class="col-12">
								<textarea name="form-descr" id="form-descr" v-model="descr" placeholder="Vollständige Beschreibung zum Vortrag/Film" rows="5" class="form-textarea"></textarea>
								<div class="pt-05 col-12">
									<p class="form-descr second-color">Eine vollständige Beschreibung zum Vortrag / Film. Was ist das Thema? (Keine Längenbegrenzung)</p>
								</div>
							</div>

							<!-- Coverfoto + optionale fotos upload-->
							<div class="col-12">
								<vue-dropzone ref="myVueDropzoneCover" id="dropzoneCover" @vdropzone-sending="sendingEvent" @vdropzone-success="onUploadCoverSuccess" @vdropzone-error="onUploadError" :options="dropzoneOptionsCover"></vue-dropzone>
								<p class="form-descr second-color">Dieses Bild repräsentiert deinen Vortrag/Film. (Minimum 512px)</p>
							</div>
							<!-- Optionale Fotos -->
							<div class="col-12">
								<vue-dropzone ref="myVueDropzoneAdditional" id="dropzoneAdditional" @vdropzone-sending="sendingEvent" @vdropzone-success="onUploadCoverAdditional" @vdropzone-error="onUploadError" :options="dropzoneOptionsAdditional"></vue-dropzone>
								<p class="form-descr second-color">Bilder, die weitere Einblicke in deinen Vortrag / Film geben (Minimum 512px)</p>
							</div>

							<!-- Personal -->

							<h2 class="mt-3 col-12 mb-1">Daten zum Referenten</h2>
							<div class="pt-05 col-12"><p class="form-descr second-color">Für Rückfragen sowie zur Präsentation des Vortragenden benötigen wir folgende Kontaktdaten. Diese Daten sind öffentlich einsehbar.</p></div>
							<div class="col-12">
								<input type="text" name="name" id="form-name" v-model="name" placeholder="Name">
							</div>
							<div class="col-12">
								<input type="email" name="email" id="form-email" v-model="email" placeholder="E-Mail-Adresse">
							</div>
							<div class="col-12">
								<textarea name="form-vita" id="form-vita" v-model="vita" placeholder="Vita" rows="2" class="form-textarea"></textarea>
								<div class="col-12">
									<p class="form-descr second-color">1-3 Sätze zu Dir. Wer bist Du? Was machst Du? Wofür bist du bekannt?</p>
								</div>
							</div>

							<!-- Portraitfoto -->
							<div class="col-12">
								<vue-dropzone ref="myVueDropzone" id="dropzone" @vdropzone-sending="sendingEvent" @vdropzone-success="onUploadSuccess" @vdropzone-error="onUploadError" :options="dropzoneOptions"></vue-dropzone>
								<p class="form-descr second-color">Dieses Bild erscheint als Kreis unter der Rubrik "Referenten" sowie im Titelbild deines Vortrags/Films. (Minimum 512px)</p>
							</div>

							<!-- Optionale Persönliche Felder -->
							<div class="col-12">
								<input type="text" name="address" id="form-address" v-model="address" placeholder="Anschrift (optional)">
							</div>
							<div class="col-6 col-12-xsmall">
								<input type="text" name="url" id="form-url" v-model="url"  placeholder="Webseite (optional)">
							</div>
							<div class="col-6 col-12-xsmall">
								<input type="text" name="tel" id="form-tel" v-model="tel" placeholder="Telefonnummer (optional)">
							</div>
							<div class="col-6 col-12-xsmall">
								<input type="text" name="instagram" id="form-instagram" v-model="instagram"  placeholder="Instagram Seite (optional)">
							</div>
							<div class="col-6 col-12-xsmall">
								<input type="text" name="facebook" id="form-facebook" v-model="facebook"  placeholder="Facebook Seite (optional)">
							</div>

							<!-- Herzensprojekt -->
							<h2 class="mt-3 col-12 mb-1">Herzensprojekt</h2>
							<div class="pt-05 col-12"><p class="form-descr second-color">Welches soziale Projekt möchtest du mit deinem Vortrag / Film unterstützen?</p></div>
							<div class="row">
								<div class="col-6 col-12-small pt-1">
									<!-- <multiselect v-model="selectedCategories" tag-placeholder="Add this as new tag" placeholder="Search or add a tag" label="name" track-by="id" :options="sortedCategories" :multiple="true" :taggable="true" :max="3" :hideSelected="true"></multiselect>-->
									<select name="category" id="category1" v-model="selectedCatId">
										<option value="0">Projekt wählen</option>
										<option v-for="(cat,index) in projects" :key="index" :value="cat.id">{{cat.title}}</option>
									</select>
								</div>
								<div class="col-6 col-12-small">Hast du weitere Projektvorschläge, dann schreibe diese bitte in das folgende Feedback Feld.</div>
							</div>

							<!-- Feedback -->
							<h2 class="mt-3 col-12 mb-0">Feedback (optional)</h2>
							<div class="col-12 pt-05">
								<div class="textarea-wrapper">
									<textarea name="form-feedback" id="form-feedback" placeholder="" rows="1" style="overflow: hidden; resize: none; height: 69px;"></textarea>
									<div class="pt-05 col-12"><p class="form-descr second-color">Möchtest du uns noch etwas sagen, dann ist das die richtige Stelle.</p></div>
								</div>
							</div>
							
							<div v-if="error" class="pt-05 col-12"><p class="form-error">Es ist leider ein Fehler aufgetreten. Bitte versuch es nocheinmal oder trete mit uns in Kontakt, über das Formular ganz unten. Danke und Entschuldigung.</p></div>
							<div v-if="hasEmptyField" class="pt-05 col-12"><p class="form-error">Wir benötigen das Feld "{{emptyField}}", um ein vollständiges Profil für deien Vortrag / Film anzulegen.</p></div>
							<div class="field">
								<input type="checkbox" id="dsgvo-check" name="dsgvocheck"  v-model="dsgvoChecked">
								<label for="dsgvo-check">Ich habe die <a href="#" @click.stop.prevent="showDatenschutzModal">Datenschutzbestimmungen</a> für die Verarbeitung meiner persönlichen Daten gelesen</label>
							</div>
							<div class="col-12">
								<ul class="actions">
									<input type="hidden" id="data" name="data"  :value="dataAsString">
									<li class="w-100"><input type="submit" value="Vortrag jetzt einreichen" :disabled="!dsgvoChecked" class="second-bgcolor primary fit"></li>
								</ul>
							</div>
						</div>
					</form>
				</section>
				<section v-else>
					<div class="row gtr-uniform">
						<h2 class="second-color col-12 mb-1">Perfekt. Geschafft.</h2>
						<p>
							<section>
							<p>Wir werden nun deinen eingereichten Vortrag / Film prüfen und uns mit Dir abstimmen, welche Schritte noch notnwendig sind und wann es losgehen kann. Schön, dass du mit dabei bist. :-)</p>
							</section>
						</p>
					</div>
				</section>
			</div>
		</div>
		<!-- Modals -->
		<RTmodal ref="datenschutzModal">
            <RTdatenschutz/>
        </RTmodal>
	</div>
</template>

<script>
import Vue from 'vue'

// import Multiselect from 'vue-multiselect'
import RTmodal from '@/components/RTmodal.vue'
import RTdatenschutz from '@/components/RTdatenschutz.vue'

import {projectBase} from '@/mixins/projectBase.js'
import {categoryBase} from '@/mixins/categoryBase.js'
import {helper} from '@/mixins/helper.js'


import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
export default {
	name: 'FormView',
	mixins:[helper,categoryBase,projectBase],
	components: {
		RTmodal,
		RTdatenschutz,
		vueDropzone: vue2Dropzone
		// Multiselect
	},
	data(){
		return{
			title:"",
			teaser:"",
			descr:"",
			vita:"",
			url:"",
			instagram:"",
			facebook:"",
			address:"",
			selectedCatId:0,
			selectedTopCatIds:[],
			name:"",
			email:"",
			tel:"",
			img:"",
			cover:"",
			imgAdditional:[],
			IMG_FOLDER:"/upload/",
			dsgvoChecked:false,
			submitted:false,
			error:false,
			emptyField:null,
			token:"jhsZZb5sb*#GbvxSms33DDfsI3#*Y9s",
			postUrl:"/mitmachen.php"
		}
	},
	computed:{

		dropzoneOptionsAdditional(){
			let o=this._.clone(this.dropzoneOptions);
			o.maxFiles=3;
			o.dictDefaultMessage= "<i class='icon solid fa-image mr-1'></i>Max 3 optionale Bilder zum Vortrag/Film";
			return o;
		},

		dropzoneOptionsCover(){
			let o=this._.clone(this.dropzoneOptions);
			o.dictDefaultMessage= "<i class='icon solid fa-image mr-1'></i>Coverfoto";
			return o;
		},

		dropzoneOptions() {
			return {
				url: '/pro.php',
				/* thumbnailWidth: 150, */
				/* maxThumbnailFilesize:1, */
				maxFilesize: 20,
				maxFiles:1,
				createImageThumbnails:false,
				dictDefaultMessage: "<i class='icon solid fa-image mr-1'></i>Persönliches Portraitfoto",
				resizeWidth:1200,
				resizeQuality:0.9,
				addRemoveLinks:true,
				acceptedFiles:"image/*",
				/* resizeMimeType:"image/jpeg" */
			}
		},

		hasEmptyField(){
			return this.emptyField!=null;
		},

		dataAsString(){
			let referentObj=this.referentObject();
			let filmData=this.dataObject(referentObj.id);
			return 'Referent: '+JSON.stringify(referentObj)+' || Film: '+JSON.stringify(filmData);
		},
	},
	methods:{

		dataObject(author_id){

			let uuid=(this.title)?(this.removeWhiteSpace(this.title.trim()).toLowerCase()):this.newUuid()

			return {
				"id":uuid,
				"date":"",//TODO
				"endDate":"", //TODO
				"title":this.title.trim(),
				"author":this.name.trim(),
				"referent_id":author_id,
				"avatar":this.img,
				"cover":this.cover,
				"pics":this.imgAdditional,
				"teaser":this.teaser.trim(),
				"descr":this.descr.trim(),
				"stream_url":"", //TODO
				"project_id":this.selectedCatId,
				"active":true
			}
		},

		referentObject(){
			let uuid=(this.name)?(this.removeWhiteSpace(this.name.trim()).toLowerCase()):this.newUuid();
			return {
				"id":uuid, 
				"name":this.name.trim(),
				"avatar":this.img,
				"address":this.address.trim(),
				"tel":this.tel.trim(),
				"email":this.email.trim(),
				"url":this.url.trim(), 
				"instagram":this.instagram.trim(), 
				"facebook":this.facebook.trim(),
				"vita":this.vita,
				"active":true
			}
		},

		hasValidPostData(){

			this.emptyField=null;

			if(this.title.trim()==""){
				this.emptyField="Überschrift";
			}else if(this.teaser.trim()==""){
				this.emptyField="Kurzbeschreibung";
			}else if(this.descr.trim()==""){
				this.emptyField="Beschreibung";
			}else if(this.email.trim()==""){
				this.emptyField="E-Mail";
			}else if(this.name.trim()==""){
				this.emptyField="Name";
			}else if(this.vita.trim()==""){
				this.emptyField="Vita";
			}

			return (this.emptyField==null);
		},

		sendingEvent (file, xhr, formData) {
			if(formData){
				formData.append('token', this.token);
			}
		},
		onUploadSuccess(file){//response
			if(file){
				this.img=this.IMG_FOLDER+file.name;
			}
		},
		onUploadCoverSuccess(file){//response
			if(file){
				this.cover=this.IMG_FOLDER+file.name;
			}
		},
		onUploadCoverAdditional(file){//response
			if(file){
				this.imgAdditional.push(this.IMG_FOLDER+file.name);
			}
		},
		
		onUploadError(file, message){//xhr
			console.log(message);
		},
		onSubmitted(e){
			if(this.hasValidPostData()){
				const formData = new FormData(e.target);
				//var formData = new FormData(document.querySelector('form'))
				this.error=false;
				this.submitted=true; //TINY FIX
				try {
					Vue.axios.post(this.postUrl,formData)
					.then((response) =>{
						// debugger // eslint-disable-line
						if (response.status >= 400) {
							this.error=true;
							throw new Error("Bad response from server");
						}
					})
					.then((data)=> {
						this.submitted=true;
						this.scrollToFormView();
						console.log(data);
					});
				} catch (error) {
					this.error=true;
				}
			}

			//document.getElementById("form_new_entry").submit();
			return false;
		},
		scrollToFormView() {
			const el = this.$refs.formView;

			if (el) {
				// Use el.scrollIntoView() to instantly scroll to the element
				el.scrollIntoView({behavior: 'smooth'});
			}
		},
		showDatenschutzModal() {
			this.$refs.datenschutzModal.show();
		},

	},
	/*
	beforeRouteEnter: (to,from,next) => {
		next(() => {
		setTimeout(()=>{
				window.scrollTo(0, 0);
			},300);
		});
	},*/
	mounted(){
	}
}
</script>


<style>
.dz-message{
	font-family: "Source Sans Pro", Helvetica, sans-serif!important;
}
</style>

<style scoped>
	.form-textarea{
		overflow: hidden; resize: none;
	}
	.form-descr{
		font-style: italic;
	}
	.form-error{
		color:red;
		text-align: center;
		font-size: large;
	}
</style>
